import { TzDatabase } from "./engine";
import tzdata from "../data/tzdata.json";
import zonesJson from "../data/zones.json";
import mapVersion from "../data/map-version.json";

export const db = new TzDatabase(tzdata as never);

export interface ZoneInfo {
  id: string;
  countries: string[];
  coord: [number, number] | null;
  comment: string;
  /** "New York" for "America/New_York" */
  city: string;
  /** lower-cased haystack for search */
  search: string;
}

export const zoneList: ZoneInfo[] = (zonesJson as unknown as { zones: Omit<ZoneInfo, "city" | "search">[] }).zones.map((z) => {
  const city = z.id.split("/").pop()!.replace(/_/g, " ");
  return {
    ...z,
    city,
    search: [z.id.replace(/_/g, " "), ...z.countries, z.comment].join(" | ").toLowerCase(),
  };
});

export const zoneById = new Map(zoneList.map((z) => [z.id, z]));

export const dataVersions = {
  tzdata: db.version,
  map: (mapVersion as { release: string }).release,
};

export function cityName(id: string): string {
  return zoneById.get(id)?.city ?? id.split("/").pop()!.replace(/_/g, " ");
}

/** Zone ids in zone1970.tab plus any extra canonical ids (e.g. the selected one). */
export function trackedZones(extra: string[] = []): string[] {
  const ids = new Set(zoneList.map((z) => z.id));
  for (const e of extra) {
    const c = db.canonical(e);
    if (c) ids.add(c);
  }
  return [...ids];
}

export function guessLocalZone(): string {
  try {
    const id = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const c = id && db.canonical(id);
    if (c) return c;
  } catch {
    /* ignore */
  }
  return "UTC";
}
